import styled from 'styled-components';

export default function DiscountAmountInput({ value, setValue, placeholder, width, disabled }) {

  function onChangeInput(e) {
    setValue(e.target.value);
  }

  return (
    <InputView width={width} disabled={disabled}>
      <Input
        type='text'
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={onChangeInput} />
    </InputView>
  );
}

const InputView = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-end;
  align-items: center;

  padding: 0 8px;

  width: ${props => props.width}px;
  height: 30px;

  border: 1px solid #D4D4D4;
  border-radius: 5px;
  background-color: ${props => props.disabled ? '#ECECEC' : '#FFFFFF'};

  &:focus-within {
    border-color: #6DD49E;
  }

  transition: border-color 0.3s ease-in-out;
`;

const Input = styled.input`
  width: 100%;
  height: 21px;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  text-align: right;

  color: #6DD49E;
  background: transparent;

  border: none;
  outline: none;
  padding: 0;

  ::placeholder {
    color: #CBCBCB;
  }
`;
